<script lang="ts" setup>
import { onBeforeMount, onBeforeUnmount, ref, watch, onMounted } from 'vue';
import { useClaimSettingsStore } from '@/stores/claimSettings';
import { useUserSettingsStore } from '@/stores/userSettingsStore';
import { useUnreadNotificationsReportStatusStore } from '@/stores/notifications/reportStatusNotificationsStore';
import { useUnreadNotificationEventWizardStatusStore } from '@/stores/notifications/eventWizardNotificationsStore';
import { closeEventSourceConnection } from '@/stores/notifications/eventSourceConnecting';
import NotificationToasts from '@/components/toasts/notifications/notificationToasts.vue';
import { onChangeTheme } from '@/components/settingsChapters/viewChapter/utils/changeTheme';
import { useCentralSettingsStore } from '@/stores/centralSettingsStore';
import { useLayout } from '@/layout/composables/layout';
import { connectSseHub } from '@/stores/notifications/eventSourceConnecting';
import moment from 'moment';
import { loadSettings } from '@/utils/themeSettingsLoad';
import { storeToRefs } from 'pinia';
import backgroundImagePath from '@/assets/background.svg';
import { Snow } from '@/holidays/newYear/snow';

const userSettings = useUserSettingsStore();
const claimSettings = useClaimSettingsStore();
const centralSettings = useCentralSettingsStore();
const notificationsReportStore = useUnreadNotificationsReportStatusStore();
const notificationEventStore = useUnreadNotificationEventWizardStatusStore();

const { layoutConfig, changeHolidayTheme } = useLayout();
const { getCurrentUser } = userSettings;
const { fetchCurrentClaims } = claimSettings;
const { fetchReportStatusNotifications } = notificationsReportStore;
const { fetchMarketingEventsNotifications } = notificationEventStore;
const { isBackgroundImage } = storeToRefs(centralSettings);

const isMounted = ref(false);
const currentTime = ref(moment().format('mm'));
const { claims} = claimSettings
const stateForRedirect = ref(false)

const loadThemeSettings = () => {
    // Функция получения и установки данных настроек внешнего вида.
    // В ней вызывается метод из стора настроек и вызывается функция, которая заполняет данные настроек полученные с сервера
    const userCentralSettings = centralSettings.fillAllCentralSettings();
    userCentralSettings.then((centralSettingsValues) => {
        loadSettings(centralSettingsValues, centralSettings);
        isMounted.value = true;
    });
};

const unRegisterServiceWorker = () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
            registration.unregister();
        }
    });
};

// Данный вотчер выполняется каждую секунду и проверяет надо ли переключать автоматически с светлой на темную тему или наоборот
watch(
    () => currentTime.value,
    () => {
        if (isMounted.value) onChangeTheme(layoutConfig.value.theme, layoutConfig.value.darkTheme ? 'dark' : 'light', centralSettings.automaticThemeTimes);
    }
);

// Каждую секунду получает текущее время и сохраняет его в переменную
setInterval(() => (currentTime.value = moment().format('HH:mm')), 1000);

onBeforeMount(async () => {
    unRegisterServiceWorker();
    loadThemeSettings();
    setTimeout(getCurrentUser, 0);
    await fetchCurrentClaims();
    await fetchReportStatusNotifications();
    await fetchMarketingEventsNotifications();
    connectSseHub();
    // changeHolidayTheme(layoutConfig.value.holidayTheme);
});

onBeforeUnmount(() => {
    closeEventSourceConnection();
});



watch(()=> claimSettings.claims, () => {
    const path = window.location.href.toString().split('/')
    let currentPath
    const addresses = {
        "dev":'https://passport.f3pro.dev.routeam.ru/navigator',
        "stage":'https://passport.f3pro.test.routeam.ru/navigator',
        "prod":'https://passport.f3pro.ru/navigator',
    }
    for(let i =0; i< path.length; i++){
        if(path[i].includes('localhost') || path[i].includes('dev')){
            currentPath = 'dev'
        }
        if(path[i].includes('test')){
            currentPath = 'stage'
        }
        if(path[i].includes('f3pro')){
            currentPath = 'prod'
        }
        
    } 
    console.log('claimSettings',claimSettings);
    if(claimSettings.claims.size === 0){
        stateForRedirect.value = true
        setTimeout(()=>{
            window.location.href = addresses[currentPath]
        },5000)
    }   


})

</script>

<template>
    <NotificationToasts />
    <div
        :style="{
            ...(!isBackgroundImage ? { backgroundImage: `url(${backgroundImagePath})`, backgroundSize: '85%', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' } : {})
        }"
    >   <div v-if="stateForRedirect === true" class="errorClass">
            <div class="errorInnerClass">
                <div>Ошибка доступа</div>
                <div>у вас нет доступа к системе.Вы будете перенаправлены через 5 секунд...</div>
            </div>
            
        </div>
        <router-view v-else/>
    </div>
</template>
<style lang="scss">
canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}
.errorClass{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: rgb(227, 224, 224);
    z-index: 10000;
}
.errorInnerClass{
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: bold;
}
</style>
